window.addEventListener('error', (error) => {
  if (
    error?.message?.includes('Loading chunk') ||
    error?.message?.includes("Unexpected token '<'")
  ) {
    window.location.reload();
  }
});

window.addEventListener('unhandledrejection', (error) => {
  if (
    error?.reason?.message?.includes('Loading chunk') ||
    error?.reason?.message?.includes("Unexpected token '<'")
  ) {
    window.location.reload();
  }
});
